import { RootState } from '../../store';

export const getRoomsSelector = (state: RootState) => state?.roomReducer?.rooms;
